const mapStateToProps = state => 
     ({
        data: state.constanciaAfiliacionAPartidosPoliticos.data,
    });

export default mapStateToProps;
